import { Offer, NameBanner } from '@rumblefish/ui/Rumblefish23Theme';
import { StyledStack, StyledSection, SectionNameBannerStack } from './styles';
import { XRPLevelopmentProcessData } from './XRPLevelopmentProcess.data';
import type { XRPLDevelopmentProcessProps } from './XRPLevelopmentProcess.types';

export const XRPLDevelopmentProcess = ({
  ...props
}: XRPLDevelopmentProcessProps): React.ReactElement => {
  const customThresholds = [0, 32, 54, 70, 90];

  return (
    <>
      <StyledSection width="normal" id="xrpl-development-process">
        <StyledStack {...props}>
          <SectionNameBannerStack>
            <NameBanner
              type="section"
              text="Our XRPL Development Process"
              color="blue"
            />
          </SectionNameBannerStack>
        </StyledStack>
      </StyledSection>
      <Offer
        title={XRPLevelopmentProcessData.mainText}
        description={XRPLevelopmentProcessData.description}
        data={XRPLevelopmentProcessData.services}
        height={'240px'}
        thresholds={customThresholds}
      />
    </>
  );
};
